import { Box, Container, useMediaQuery, theme } from '@everlywell/ui-kit';
import Carousel from 'components/Carousel';
import SectionHeader from 'components/PageSections/components/SectionHeader';
import React from 'react';

import ShapeCard, { ShapeCardProps } from '../ShapeCard';
import InstaInspiredCarousel from './InstaInspiredCarousel';

export type InstaInspiredCarouselProps = {
  shapeCardsData?: ShapeCardProps[];
};
export interface StoriesCarouselProps extends InstaInspiredCarouselProps {
  title?: string;
  eyebrow?: string;
}

/**
 * StoriesCarousel is a component that displays a list of ShapeCard in a carousel.
 * On desktop view, the carousel will be draggable and will display the ShapeCard in a vertical layout.
 * On mobile view, the carousel will have an Instagram-like Swiper feature.
 */

const StoriesCarousel: React.FC<StoriesCarouselProps> = (
  props: StoriesCarouselProps,
): JSX.Element => {
  const { title, eyebrow, shapeCardsData } = props;

  const [isMobile] = useMediaQuery(`(max-width: ${theme.breakpoints.tablet})`);

  // On large screens, set the container size based on the number of cards.
  // Use 'sm' size if there are more than 3 cards for a fluid layout.
  // Use 'xl' size to center-align the cards if there are 3 or fewer.
  const largeScreenContainerSize =
    shapeCardsData && shapeCardsData?.length <= 3 ? 'xl' : 'sm';

  return (
    <Container
      size={['sm', null, 'lg', 'xl', largeScreenContainerSize]}
      marginY={[5, 10]}
      marginX={['auto', 'auto']}
    >
      <SectionHeader eyebrow={eyebrow} title={title} />
      {shapeCardsData ? (
        <Box>
          {isMobile ? (
            <InstaInspiredCarousel shapeCardsData={shapeCardsData} />
          ) : (
            <Box
              sx={{
                '.swiper': {
                  overflow: 'visible',
                },
              }}
            >
              <Carousel
                grabCursor={true}
                spaceBetween={16}
                slidesPerView="auto"
                pagination={shapeCardsData.length > 1}
                slideStyle={{
                  display: 'flex',
                  flexDirection: 'column',
                  height: 'auto',
                  width: '415px',
                }}
              >
                {shapeCardsData?.map((card, index) => (
                  <ShapeCard
                    cardVariant="vertical"
                    key={`shape-card-${index}`}
                    {...card}
                  />
                ))}
              </Carousel>
            </Box>
          )}
        </Box>
      ) : null}
    </Container>
  );
};

export default StoriesCarousel;
